<template>
  <div class="form-textarea">
    <!-- Question title -->
    <div v-if="questionTitle" class="text-base font-semibold leading-6 text-gray-900 py-2 mb-2">
      {{ displayQuestionTitle }}
    </div>
    
    <!-- Textarea -->
    <textarea 
      :rows="rows" 
      :name="name" 
      :disabled="disabled" 
      :value="value"
      @input="handleInput"
      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-0 focus:border-main"
      :class="{ 'opacity-50 cursor-not-allowed': disabled, 'cursor-text': !disabled }"
      :placeholder="displayPlaceholder"
    />
  </div>
</template>

<script>
import { showMultiLingualText } from '../../utils/languageUtils.js'

export default {
  name: 'FormTextarea',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    questionTitle: {
      type: [String, Object],
      default: ''
    },
    rows: {
      type: Number,
      default: 3
    },
    placeholder: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      showMultiLingualText
    }
  },
  computed: {
    displayQuestionTitle() {
      if (this.questionTitle) {
        return this.showMultiLingualText(this.questionTitle, null, false, this.$i18n.locale)
      }
      return ''
    },
    
    displayPlaceholder() {
      if (this.placeholder) {
        return this.showMultiLingualText(this.placeholder, 'Enter your answer', false, this.$i18n.locale)
      }
      return ''
    }
  },
  methods: {
    handleInput(event) {
      // Don't allow changes when disabled
      if (this.disabled) {
        event.preventDefault()
        return
      }
      
      // Create a synthetic event object that matches the expected format
      const syntheticEvent = {
        target: {
          name: this.name,
          value: event.target.value
        }
      }
      this.$emit('change', syntheticEvent)
    }
  }
}
</script> 